/*
  Seasonal campaign on the collection Shelves page.
  Reads #cm-campaign (sections/customizer-campaign.liquid, header group) and,
  while a communication is active:
    - light look: a ribbon on top (kicker + ribbon text), then the gift list
      with an italic price line;
    - dark look: the gift list with a dark box (kicker, countdown, price);
    - "Who's on your list?" people chips filter the cards of every shelf by
      who they are for (data-for on .cs-card); the format tiles step aside;
    - a line on every product card (card note, bold words in gold).
  Same rules as the customizers: ?campaign=N previews block N, ?campaign=off
  hides it, overlapping communications -> the shorter one wins.
*/
(function () {
  var mount = document.querySelector('[data-cm-collection]');
  var src = document.getElementById('cm-campaign');
  if (!mount || !src) return;
  var data;
  try { data = JSON.parse(src.textContent); } catch (e) { return; }
  if (!data || !Array.isArray(data.comms) || !data.comms.length) return;

  var root = mount.closest('[data-cs-shelves]') || document;
  var pick = root.querySelector('.css-pick');
  var extra = mount.dataset.extra || '';
  var price = mount.dataset.price || '';
  var person = null;
  var shownId = null;
  var noteEls = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function active() {
    var q = null;
    try { q = new URLSearchParams(window.location.search).get('campaign'); } catch (e) { /* ignore */ }
    if (q === 'off') return null;
    if (q && data.comms[parseInt(q, 10) - 1]) return data.comms[parseInt(q, 10) - 1];
    if (data.mode === 'off') return null;
    var now = Date.now() / 1000;
    var c = null;
    data.comms.forEach(function (x) {
      if (x.start && x.end && now >= x.start && now < x.end && (!c || x.end - x.start < c.end - c.start)) c = x;
    });
    if (!c && data.mode === 'on') c = data.comms[0];
    return c;
  }

  function left(end) {
    var s = Math.max(0, Math.floor(end - Date.now() / 1000));
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    return d ? d + 'd ' + h + 'h ' + m + 'm' : h + 'h ' + m + 'm';
  }

  function clock(c) {
    return c && c.end ? '<span class="cmc__clock" data-cmc-clock="' + c.end + '">' + esc(left(c.end)) + '</span>' : '';
  }

  // "$59" and "$29.90" -> "$29.10", keeping the currency symbol of the extra price.
  function saving() {
    var n = function (s) { return parseFloat(String(s).replace(/[^0-9.,]/g, '').replace(',', '.')); };
    var p = n(price), e = n(extra);
    if (!(p > e)) return '';
    return extra.replace(/[0-9][0-9.,]*/, (p - e).toFixed(2));
  }

  function text(t, c) {
    if (!t) return '';
    var now = new Date(); now.setHours(0, 0, 0, 0);
    var cd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data.cutoffDay || '');
    var cut = cd ? new Date(+cd[1], +cd[2] - 1, +cd[3]).getTime() : 0;
    var map = {
      date: data.cutoffLabel || '',
      n: cut ? String(Math.max(0, Math.round((cut - now.getTime()) / 864e5))) : '',
      arrival: new Date(Date.now() + (+data.arrivalDays || 20) * 864e5).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      extra_price: extra,
      price: price,
      save: saving(),
      end_date: (c && c.endLabel) || '',
    };
    return esc(t)
      .replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')
      .replace(/\r?\n/g, '<br>')
      .replace(/\[(date|n|arrival|extra_price|price|save|end_date)\]/g, function (m, k) { return esc(map[k]); })
      .replace(/\[ends\]/g, function () { return clock(c); });
  }

  var spark = '<svg class="cmc__spark" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1.5l2.2 7.1 7.3 2.4-7.3 2.4L12 20.5l-2.2-7.1L2.5 11l7.3-2.4z"/></svg>';

  function cards() { return Array.prototype.slice.call(root.querySelectorAll('.cs-card')); }

  // "Mom = her, mom" lines -> people with at least one matching card.
  function people() {
    var all = cards();
    return String(data.collPeople || '').split(/\r?\n/).map(function (line) {
      var k = line.indexOf('=');
      if (k < 1) return null;
      var name = line.slice(0, k).trim();
      var fors = line.slice(k + 1).toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var n = all.filter(function (el) { return match(el, fors); }).length;
      return name && n ? { name: name, fors: fors } : null;
    }).filter(Boolean);
  }

  function match(el, fors) {
    var mine = String(el.dataset.for || '').split(',');
    return fors.some(function (f) { return mine.indexOf(f) !== -1; });
  }

  function filter(list) {
    var p = person ? list.filter(function (x) { return x.name === person; })[0] : null;
    cards().forEach(function (el) { el.hidden = !!p && !match(el, p.fors); });
    root.querySelectorAll('[data-shelf]').forEach(function (shelf) {
      var any = shelf.querySelector('.cs-card:not([hidden])');
      shelf.hidden = !any;
      var rail = shelf.querySelector('[data-rail]');
      if (rail) rail.scrollLeft = 0;
    });
    window.dispatchEvent(new Event('resize')); // arrows and dots of each shelf re-sync
  }

  function render() {
    var c = active();
    shownId = c ? c.id : null;
    noteEls.forEach(function (el) { el.remove(); });
    noteEls = [];
    if (!c) {
      mount.hidden = true;
      mount.innerHTML = '';
      if (pick) pick.hidden = false;
      person = null;
      filter([]);
      return;
    }
    var dark = c.look === 'dark' || c.look === 'deal';
    var list = people();
    if (person && !list.some(function (x) { return x.name === person; })) person = null;
    var chips = list.length ? '<div class="cmc__people" role="group" aria-label="Who is it for">'
      + '<button type="button" class="cmc__person" data-cmc-person="" aria-pressed="' + (!person) + '">Everyone</button>'
      + list.map(function (x) {
        var on = person === x.name;
        return '<button type="button" class="cmc__person" data-cmc-person="' + esc(x.name) + '" aria-pressed="' + on + '">' + (on ? '✓ ' : '+ ') + esc(x.name) + '</button>';
      }).join('') + '</div>' : '';
    var ribbon = !dark && c.ribbon ? '<div class="cmc__ribbon"><span class="cmc__icon">' + spark + '</span><span class="cmc__ribbon-text">'
      + (c.kicker ? '<span class="cmc__kicker">' + esc(c.kicker) + '</span>' : '') + '<span>' + text(c.ribbon, c) + '</span></span></div>' : '';
    var hero = dark
      ? '<div class="cmc__deal' + (c.look === 'deal' ? ' cmc__deal--deal' : '') + '"><div class="cmc__deal-top"><span class="cmc__kicker">' + spark + ' ' + esc(c.listKicker || c.kicker || '') + '</span>' + clock(c) + '</div>'
        + (c.collHero ? '<span class="cmc__deal-hero">' + text(c.collHero, c) + '</span>' : '')
        + (c.collSmall ? '<span class="cmc__deal-small">' + text(c.collSmall, c) + '</span>' : '') + '</div>'
      : (c.collHero ? '<p class="cmc__hero">' + text(c.collHero, c) + '</p>' : '')
        + (c.collSmall ? '<p class="cmc__small">' + text(c.collSmall, c) + '</p>' : '');
    mount.innerHTML = ribbon
      + '<div class="cmc__list">'
      + (!dark && c.listKicker ? '<span class="cmc__kicker">' + esc(c.listKicker) + '</span>' : '')
      + (c.collTitle ? '<h2 class="cs-h2 cmc__title">' + text(c.collTitle, c) + '</h2>' : '')
      + chips + hero + '</div>';
    mount.hidden = false;
    if (pick) pick.hidden = true;
    if (c.cardNote) {
      cards().forEach(function (el) {
        var body = el.querySelector('.cs-card__body');
        if (!body) return;
        var n = document.createElement('div');
        n.className = 'cmc__note' + (dark ? ' cmc__note--shine' : '') + (c.look === 'deal' ? ' cmc__note--deal' : '');
        n.innerHTML = text(c.cardNote, c);
        body.appendChild(n);
        noteEls.push(n);
      });
    }
    filter(list);
  }

  mount.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cmc-person]');
    if (!b) return;
    var who = b.getAttribute('data-cmc-person');
    person = who && person !== who ? who : null;
    render();
  });

  render();
  setInterval(function () {
    var c = active();
    if ((c ? c.id : null) !== shownId) { render(); return; }
    document.querySelectorAll('[data-cmc-clock]').forEach(function (el) { el.textContent = left(+el.getAttribute('data-cmc-clock')); });
  }, 15000);
})();
